















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import MyComponent from './components/my-component.vue'
import yikeSellLog from '../node_modules/@imp/package/lib/zyb-yike-utils/yikeSellLog'
import browser from '../node_modules/@imp/package/lib/zyb-yike-utils/browser'
import guid from '../node_modules/@imp/package/lib/zyb-yike-utils/guid'
import hybrid from '../node_modules/@imp/package/lib/zyb-yike-utils/hybridProxy'
import terminalType from '../utils/terminalType'
import { getQueryofKey, getQueryString } from '../utils/getUrlParams'
import setFlowPond from '../utils/setFlowPond'
// import handleShare from '../node_modules/@imp/package/common/methods/weixin'
import handleShare from '../node_modules/@imp/package/lib/methods/weixin'
import dotApi from '../node_modules/@imp/package/lib/dot-api'
// import methods from '../node_modules/@imp/package/lib/methods'
import request from '../node_modules/@imp/package/lib/request'
import { ComponentTypeEnum } from '../node_modules/@imp/package/typings/enum/component-type'
import { platform } from '../node_modules/@imp/package/lib/utils/platform'
import { errorDot } from '../node_modules/@imp/package/lib/utils/errorDot'
import axios from 'axios'
import uuidV4 from 'uuid/v4'
import baseURL from '../utils/requestUrl'
import terminalCheck from '../node_modules/@imp/package/lib/zyb-yike-utils/terminalCheck'
import get from 'lodash/get'
import { zs } from '@zyb-data/stats-wp'
import { wxAuthorize } from './outApp/wechat-auth'
import { flowPondInit } from './outApp/flow-pond'
import originConfig from '../node_modules/@imp/package/lib/url/originConfig'
import isNeedToPreRequestKfLink from '../node_modules/@imp/package/lib/utils/wxkf'
import {
  updateFlowPond,
  getFlowPond,
  ZybAuthorizeDialog,
} from 'cube-dialog-sdk'
axios.defaults.withCredentials = true
// 添加一行注释，改变文件hash
// 以下类型组件不需要打展现点
const IgnoreDot = [
  ComponentTypeEnum.hotarea,
  ComponentTypeEnum.dialog,
  // ComponentTypeEnum.container,
]
let refreshTimeout: any = '' // 刷新记录倒计时接收器，避免异常情况
@Component({
  components: {
    MyComponent,
  },
})
export default class App extends Vue {
  @Prop({ type: Object }) globalData!: any
  componentArray: any = []
  pageInfo: any = {}
  actInfo: any = {}
  componentDomArray: any = []
  fixedComponentDomArray: any = []
  calcComponentArray: any = {}
  // pageContent里的 所有的组件, key=uid
  tempDomList: any = {}
  flowPond: any = {}
  window: any
  pageShow: boolean = true
  data() {
    return {
      pageInfo: this.globalData.pageData.pageInfo,
      actInfo: this.globalData.pageData.actInfo,
      componentArray: this.globalData.pageData.pageInfo.pageContent,
      tempDomList: {},
      flowPond: {},
    }
  }
  // 页面以及组件加载后组件展现点
  @Watch('pageShow', { immediate: true })
  pageShowChange(val: any) {
    if (!Vue.prototype.$isServer && val) {
      this.$nextTick(() => {
        this.handlePageDot()
      })
    }
  }
  isInApp() {
    const type = terminalType()
    return (
      type === 'homework' ||
      type === 'homework_knowledge' ||
      type === 'airclass' ||
      type === 'parent' ||
      type === 'haokezaixian' ||
      type === 'youketang'
    )
  }
  refreshPage() {
    this.actInfo.expireTime = this.actInfo.expireTime | 0
    if (this.actInfo.expireTime <= 0) {
      return
    }
    if (refreshTimeout) {
      clearTimeout(refreshTimeout)
    }
    refreshTimeout = setTimeout(() => {
      this.actInfo.expireTime -= 2
      if (this.actInfo.expireTime <= 0) {
        window.location.reload()
      } else {
        this.refreshPage()
      }
    }, 2000)
  }
  async created() {
    if (!Vue.prototype.$isServer) {
      let source = (window as any).__PAGE_DATA__.actInfo.source
      // 设置sessionId
      if (getQueryofKey('sessionId')) {
        ;(window as any).__PAGE_DATA__.sessionId = getQueryofKey('sessionId')
      } else {
        ;(window as any).__PAGE_DATA__.sessionId = uuidV4()
      }
      // 处理分享信息
      let sharePic = this.actInfo.sharePic
      let titleStyle = this.actInfo.titleStyle
      if (sharePic.indexOf('.jpg') !== -1) {
        sharePic = sharePic + '@w_100'
      }
      // 兼容安卓手机设置了分享后hideNativeTitleBar不好用的问题
      if (
        source !== 2 &&
        (!this.isInApp() ||
          (this.isInApp() && titleStyle !== 2 && titleStyle !== 3))
      ) {
        this.setShareMes({
          isShare: this.actInfo.isShare,
          shareTitle: this.actInfo.shareTitle,
          sharePic: sharePic,
          shareDesc: this.actInfo.shareDesc,
        })
      }
      // 关闭端内loading
      if (platform.isInZybApp || platform.isInParentApp) {
        hybrid('closeLoad')
      } else if (platform.isInYikeApp && platform.isIOS) {
        hybrid('core_removeLoading')
      }

      // 端外投放场景，微信环境初始化
      this.flowPond = updateFlowPond({})
      let pageData = (window as any).__PAGE_DATA__
      let flowPondParams = {
        cubeSessionId: pageData.sessionId,
        orifacId:
          this.flowPond['orifacId'] === '0'
            ? this.actInfo.actId
            : this.flowPond['orifacId'],
        fcid: this.actInfo.actId,
        actId: this.actInfo.actId,
        mofangActType: source,
        lastpageid: pageData.pageInfo.pageId,
        marketType: getQueryofKey('marketType'),
        // gradeid:
        //   this.flowPond['gradeid'] === '0'
        //     ? getQueryofKey('grade')
        //     : this.flowPond['gradeid'],
        version: getQueryofKey('version'),
      }
      if (source === 2) {
        if (location.host.indexOf('.xingmangmeixue.com') > 0) {
          // 星芒美学没有微信授权
          flowPondInit()
          // 处理参数flowpond
          this.flowPond = setFlowPond(flowPondParams)
        } else if (location.host.indexOf('.zuoyebang.com') > 0 || location.host.indexOf('.zybjianzhan.com') > 0) {
          await wxAuthorize()
          flowPondInit()
          // 处理参数flowpond
          this.flowPond = setFlowPond(flowPondParams)
        } else {
          await wxAuthorize()
          flowPondInit()
        }
      } else {
        this.flowPond = updateFlowPond(flowPondParams)
      }
      if (platform.isInParentApp) {
        // 口算全埋点初始化:更换打点action
        this.setDotAction(zs).then(res => {
          this.initAllDotSdk()
        })
      } else {
        // 其余端全埋点初始化
        this.initAllDotSdk()
      }
    }
    // 将flowPond挂到window上， 方便其他地方调用
    ;(window as any).flowPond = this.flowPond
    // 得到所有的组件 包括子组件
    this.getAllComponentList(this.componentArray)
    this.customerMonitor()
    if (refreshTimeout) {
      clearTimeout(refreshTimeout)
    }
  }

  beforeMount() {
    // console.log(process.env.VUE_APP_SECRET)
    // 如果 cookie 没有 uuid，那么就定义一个，用来标示用户
    let domains = document.domain.split('.')
    let secDomain = `.${domains[1]}.${domains[2]}`
    if (document.cookie.indexOf('uuid=') === -1) {
      document.cookie = `uuid=${guid(32)};path=/`
    }
    let { source, subSource } = this.actInfo
    if (
      +source === 1 &&
      +subSource === 102 &&
      terminalCheck.isInmimiProgram()
    ) {
      // 小程序内嵌H5的话，需要追加cookies
      let APPLETUSS = getQueryofKey('APPLETUSS')
      document.cookie = `APPLETUSS=${APPLETUSS};domain=${secDomain};path=/`
    }
  }

  mounted() {
    let { status, propsData } = this.pageInfo
    // 页面曝光增加监控
    errorDot({
      dependType: 9,
      req: JSON.stringify({
        actId: this.actInfo.actId,
        pageId: this.pageInfo.pageId,
        flowPond: this.flowPond,
      }),
      res: '',
    })
    let answerResult: any = getQueryofKey('answerResult')
    if (answerResult) {
      try {
        answerResult = JSON.parse(answerResult)
      } catch {
        answerResult = {}
      }
    }
    if (this.isInApp()) {
      // 端内上报userid，给直播使用
      hybrid('getuserinfo', {}, (res: any) => {
        // 页面PV 端内外走的方式不同
        dotApi.pageShow({
          pageId: this.pageInfo.pageId,
          groupId: this.actInfo.groupId,
          imp: propsData[status].description['impView'],
          userid: res.uid,
          marketType: this.actInfo.marketType,
          customParams: {
            skuId: answerResult && answerResult.skuId,
            questionGroupId: answerResult && answerResult.groupId,
            questionGroupName: answerResult && answerResult.groupName,
            questionResultId: answerResult && answerResult.id,
            questionnaireId: answerResult && answerResult.questionnaireId,
          },
        })
        // 页面PV 都走端外打点方式
        dotApi.selfShow({
          pageId: this.pageInfo.pageId,
          groupId: this.actInfo.groupId,
          userid: res.uid,
          marketType: this.actInfo.marketType,
        })
      })
    } else {
      // 页面PV 端内外走的方式不同
      dotApi.pageShow({
        pageId: this.pageInfo.pageId,
        groupId: this.actInfo.groupId,
        imp: propsData[status].description['impView'],
        marketType: this.actInfo.marketType,
        customParams: {
          skuId: answerResult && answerResult.skuId,
          questionGroupId: answerResult && answerResult.groupId,
          questionGroupName: answerResult && answerResult.groupName,
          questionResultId: answerResult && answerResult.id,
          questionnaireId: answerResult && answerResult.questionnaireId,
        },
      })
      // 页面PV 都走端外打点方式
      dotApi.selfShow({
        pageId: this.pageInfo.pageId,
        groupId: this.actInfo.groupId,
        marketType: this.actInfo.marketType,
      })
    }
    // 校验是否需要登录
    const cdn = this.globalData.pageData.actInfo.cdn
    // 如果启用cdn前置登录换为ajax请求用户信息
    if (cdn === 1) {
      this.cdnLoginMethods()
    } else {
      this.loginMethods()
    }
    // 监听活动是否过期
    this.refreshPage()
    if (
      this.isInApp() ||
      terminalCheck.isInMMApp() ||
      terminalCheck.isInTYApp()
    ) {
      setTimeout(() => {
        // 只有端内才执行
        if (!Vue.prototype.$isServer) {
          this.getHandleSchemeSetting()
        }
      }, 100)
      // 端内激活webviwe,调用方法
      setTimeout(() => {
        let winObj = window as any
        winObj.fePageResume = () => {
          if (winObj.arrFePageResume && winObj.arrFePageResume.length > 0) {
            winObj.arrFePageResume.forEach((fun: Function) => {
              fun()
            })
          }
        }
      })
    }
    // 通过接口获取最新的客服链接，并存放到pageInfo的globalData里
    let { wxkfParams } = this.pageInfo.globalData
    const wxkfParamsCache: any = {}
    if (wxkfParams && wxkfParams.length !== 0) {
      const fn = async () => {
        for (let item of wxkfParams) {
          // 判断环境  是否需要请求b链接
          let okFlag = await isNeedToPreRequestKfLink(
            item.corpId,
            item.uid,
            item.actionIndex
          )
          let key = item.corpId + '-' + item.openKfId
          if (
            wxkfParamsCache.hasOwnProperty(key) &&
            wxkfParamsCache[key] !== ''
          ) {
            // 根据客服id、主体id请求过了 并且有值 就直接取值
            item.kflink = wxkfParamsCache[key]
          } else {
            if (item.openKfId && item.corpId && okFlag) {
              let res: any = await this.getWexinKfLink({
                openKfid: item.openKfId,
                corpId: item.corpId,
              })
              wxkfParamsCache[key] = item.kflink = res.kflink
            }
          }
        }
      }
      fn()
    }
    ;(window as any).__PAGE_DATA__.pageInfo.globalData.wxkfParams = wxkfParams
    setTimeout(() => {
      const componentList =
        (window as any).__PAGE_DATA__.pageInfo.componentList || []
      ;(window as any).__AppletTypeIdMap__ = {}
      ;(window as any).__OpentWxAppletTypeIdMap__ = {}
      this.recursionComponentList(componentList)
    }, 100)
  }
  destroyed() {
    if (refreshTimeout) {
      clearTimeout(refreshTimeout)
    }
  }
  // 获取云控策略，设置外跳app是否展示弹窗的配置
  async getHandleSchemeSetting() {
    const flowPond = (window as any).flowPond || {}
    // 默认是1，打开，0是不打开
    if (flowPond.handleScheme != 0) {
      ;(window as any).zybAuthorizeDialog = new ZybAuthorizeDialog({
        handleScheme: flowPond.handleScheme,
      })
      await (window as any).zybAuthorizeDialog.init()
    }
  }
  customerMonitor() {
    let arr = Object.values(this.tempDomList)
    let skuIds: Array<any> = []
    arr.forEach(item => {
      let actionObj: any = get(item, 'propsData[0].actions[0]') || {}
      let { actionType, params } = actionObj
      if (actionType === 'appletSpecialPayment') {
        params.skuData.forEach((sku: any) => {
          if (sku.skuId) {
            skuIds.push(sku.skuId)
          }
        })
      }
    })
    // 小程序三合一上报
    if (terminalCheck.isInmimiProgram() && skuIds.length) {
      errorDot({
        dependType: 11,
        req: JSON.stringify({
          skuIds: skuIds.join(','),
        }),
        res: '',
      })
    }
  }

  // cdn判断登录逻辑
  cdnLoginMethods() {
    const preLogin = this.globalData.pageData.pageInfo.globalData.preLogin
    if (this.isInApp()) {
      if (preLogin) {
        // 只有前置登录判断端内是否登录
        this.appLogin()
      }
    } else {
      // 端外判断登录
      let url = '/cube/api/getuserinfo'
      // 传给后端cuid，返回gradeid
      let cuid = getQueryofKey('cuid')
      if (!cuid) {
        cuid = this.flowPond.cuid
      }
      if (cuid) {
        url = url + '?cuid=' + cuid
      }
      axios({
        baseURL,
        url: url,
        method: 'GET',
      })
        .then(res => {
          if (res.data.data.uid > 0) {
            ;(window as any).__PAGE_DATA__.isLogin = 1
            ;(window as any).__PAGE_DATA__.cdnGrade =
              res.data.data.cdnGrade || res.data.data.grade
            ;(window as any).__PAGE_DATA__.cdnGradeDes =
              'cdnGrade为cdn页面兜底的grade获取方式，排在fngrade、grade之后'
            this.flowPond = updateFlowPond({
              uid: res.data.data.uid,
            })
          } else if (preLogin) {
            this.webLogin()
          }
        })
        .catch(err => {})
    }
  }
  // 非cdn判断登录逻辑
  loginMethods() {
    const preLogin = this.globalData.pageData.pageInfo.globalData.preLogin
    const isLogin = this.globalData.pageData.isLogin
    // 未启用cdn前置登录
    if (preLogin && !isLogin) {
      // 跳转登录链接
      if (this.isInApp()) {
        // 判断端内是否登录
        this.appLogin()
      } else {
        // 端外跳转登录
        this.webLogin()
      }
    }
  }
  // 端内登录逻辑
  appLogin() {
    const preLogin = this.globalData.pageData.pageInfo.globalData.preLogin
    hybrid('is_login', {}, (result: any) => {
      if (result.isLogin) {
        ;(window as any).__PAGE_DATA__.isLogin = 1
      } else {
        if (preLogin) {
          hybrid('loginForResult', { fr: 'mofang' }, (data: any) => {
            if (data.isLogin || data.result) {
              ;(window as any).__PAGE_DATA__.isLogin = 1
            } else {
              hybrid('exit')
            }
          })
        }
      }
    })
  }
  // 获取微信B链接
  getWexinKfLink(data: any) {
    let extdata = getQueryofKey('extdata')
    let grade = getQueryofKey('grade')
    let cuid = getQueryofKey('cuid')
    let flowPond = (window as any).flowPond
    let pvid = flowPond.pvid || flowPond.guideUniqid
    let pvidKey = pvid && pvid.replace(/-/g, '')
    let uid = (<any>window).__PAGE_DATA__.userInfo.uid || 0
    return new Promise((resolve, reject) => {
      request
        .post('/cube/wxkf/getkflink', {
          openKfid: data.openKfid,
          corpId: data.corpId,
          pvid: pvidKey,
          isNewAct: 1,
          valueMap: JSON.stringify({
            cuid,
            extdata,
            pvid,
            gradeid: +grade,
            uid: uid,
            MFactionid: this.actInfo.actId,
          }),
        })
        .then((res: any) => {
          console.log(11111, res)
          resolve(res)
        })
        .catch(() => {
          reject()
        })
    })
  }
  // 端外跳转登录
  webLogin() {
    let origin = location.origin
    if (origin.indexOf('suanshubang') !== -1) {
      origin = 'https://base-docker.suanshubang.com'
    } else {
      origin = originConfig.loginOrigin
    }
    location.href = `${origin}/passport/login?redirect=${encodeURIComponent(
      location.href
    )}`
  }
  /**
   * 微信分享
   */
  setShareMes(conf: any) {
    // todo 超哥 引导框
    if (Number(conf.isShare) === 1 || !this.isInApp()) {
      let { shareDesc, shareTitle, sharePic } = conf
      let type = terminalType()
      let defaultIcon
      if (type === 'airclass') {
        defaultIcon =
          'https://yy-s.zuoyebang.cc/static/laxin_weixin_share/yike_logo.png'
      } else {
        defaultIcon =
          'https://yy-s.zuoyebang.cc/static/laxin_weixin_share/zyb_logo.png'
      }
      // 当前为活动时，显示的是活动的分享首页  ---- todo 确认链接是否拼接正确---
      let url = location.origin + location.pathname
      if (this.actInfo && this.actInfo.actId) {
        url = `${location.origin}/cube/act/display?actId=${this.actInfo.actId}&groupId=${this.actInfo.groupId}`
      }
      /**
       * cdn分享
       */
      if (window.location.host.indexOf('.zuoyebang.com') !== -1) {
        url = `${location.origin}${location.pathname}?actId=${this.actInfo.actId}&groupId=${this.actInfo.groupId}`
      }
      const lastfrom = getQueryofKey('lastfrom')
      const fr = getQueryofKey('fr')
      const logpath = getQueryofKey('logpath')
      const flowPond = encodeURIComponent(
        JSON.stringify((window as any).flowPond)
      )
      url =
        url +
        (url.indexOf('?') > -1 ? '&' : '?') +
        `lastfrom=${lastfrom}&fr=${fr}&logpath=${logpath}&pageShare=1&flowPond=${flowPond}`

      // 直卖 分享需要添加此参数
      const saleChannel = getQueryofKey('saleChannel')
      if (saleChannel) {
        url = `${url}&saleChannel=${saleChannel}`
      }
      // 由于端外ios，存在跨域问题，域名需要替换成zuoyebang.com，目前只在分享做替换，并且只替换域名
      url = url.replace('zybang.com', 'zuoyebang.com')
      let shareType = [0, 1, 2, 3, 4]
      if (terminalCheck.isYouKeTangApp()) {
        shareType = [2, 3]
      }
      handleShare(
        {
          url:
            platform.isIOS && platform.isInHaoKeApp
              ? encodeURIComponent(url)
              : url, // 分享链接，一般为当前页面的链接
          content: shareDesc || '作业帮',
          title:
            shareTitle !== undefined ? shareTitle : this.pageInfo.pageTitle,
          pic: sharePic === undefined || !sharePic ? defaultIcon : sharePic,
          pageInfo: this.pageInfo,
          actInfo: this.actInfo,
          orifacId: this.flowPond.orifacId,
          shareType,
          cb: () => {
            // 抽奖分享添加机会
            if (this.pageInfo.globalData.lotteryId) {
              let actConfig =
                (<any>window).__PAGE_DATA__ &&
                (<any>window).__PAGE_DATA__.actInfo.actConfig
              if (actConfig) {
                let lotteryId = JSON.parse(actConfig).lotteryId
                if (lotteryId) {
                  request
                    .get('/cube/api/share', {
                      lotteryIds: Object.values(lotteryId)
                        .join(',')
                        .split(','),
                    })
                    .then(() => {
                      let pageInfo = (<any>window).__PAGE_DATA__.pageInfo
                      if (
                        pageInfo.globalData &&
                        pageInfo.globalData.lotteryId &&
                        pageInfo.globalData.lotteryId.length > 0
                      ) {
                        window.location.reload()
                      }
                    })
                }
              }
            }
          },
        },
        true
      )
    }
  }
  getAllComponentList(list: any) {
    list = list ? list : this.componentArray
    list.map((item: any) => {
      this.tempDomList[item.uid] = item
      if (item.componentList.length > 0) {
        this.getAllComponentList(item.componentList)
      }
    })
  }
  setDotAction(sdk: any) {
    return new Promise((resolve, reject) => {
      hybrid('common', (res: any) => {
        if (res) {
          const { vc } = res
          sdk.setLogActionName(
            vc >= 490 ? 'zybTrackerStatisticsAction' : 'liveStatSendData'
          )
        } else {
          sdk.setLogActionName('liveStatSendData')
        }
        resolve(true)
      })
    })
  }
  /**
   * 全埋点初始化
   */
  initAllDotSdk() {
    try {
      var { pageInfo, actInfo } = (window as any).__PAGE_DATA__
      var pageDots = pageInfo.pageDots

      var isShare = actInfo.isShare
      var systemId = actInfo.systemId
      var actName = actInfo.actName
      let exclude: any = [] // 要排除默认组件展现的组件id集合
      let componentDomArray = document.querySelectorAll('.niffler-container')
      // 处理参数flowpond
      if (componentDomArray.length > 0) {
        // 判断带有dot-self的组件，阻止默认的组件展现打点
        componentDomArray.forEach((item: any) => {
          if (item.children[0] && item.children[0].getAttribute('dot-self')) {
            exclude.push(item.getAttribute('niffleruid'))
          }
        })
      }
      var args = [
        'flowPond',
        'orifacId',
        'fcid',
        'pageShare',
        'url',
        'pageId',
        'sessionId',
        'lastfrom',
        'ZYBUSS',
        'gradeId',
        'groupId',
        'marketType',
        'os',
        't',
        'orifrom',
        'logpath',
        'tplPath',
        'pageName',
        'systemId',
        'actName',
        'browser',
        'isAutoPoint',
        'actId',
        'cuid',
        'mofangActType',
      ]
      var mockPageDtos = (function() {
        var r: any = []
        r.push({
          codeName: `IMP${pageInfo.pageId}_0_7_00`,
          desc: '停留时长',
          eid: '',
          type: 1,
          args,
          et: 'pageHide',
        })
        return r
      })()
      let answerResult: any = getQueryofKey('answerResult')
      if (answerResult) {
        try {
          answerResult = JSON.parse(answerResult)
        } catch {
          answerResult = {}
        }
      }
      let { source, subSource } = this.actInfo
      let pageType = (<any>window).__PAGE_DATA__.pageInfo.globalData.pathType
      if (+source === 1 && +subSource === 103) {
        let pageId = (<any>window).__PAGE_DATA__.pageInfo.pageId
        let groupInfo: any = {}
        if (actInfo?.router) {
          groupInfo = JSON.parse(actInfo.router)?.groupInfo
        }
        if (groupInfo[2]?.pageList.indexOf(pageId) > -1) {
          pageType = 3 // 入队页
        } else if (groupInfo[3]?.pageList.indexOf(pageId) > -1) {
          pageType = 2 // 邀请页
        } else {
          pageType = 1 // 活动页
        }
      }
      var globalData = {
        pageId: pageInfo.pageId,
        groupId: pageInfo.groupId,
        pageName: pageInfo.pageName,
        pageShare: isShare,
        systemId,
        actName,
        orifacId: this.flowPond.orifacId,
        gradeId: this.flowPond.gradeid,
        fcid: pageInfo.actId,
        flowPond: getFlowPond(),
        url: location.href,
        sessionId: (<any>window).__PAGE_DATA__.sessionId,
        lastfrom: getQueryofKey('lastfrom'),
        marketType: actInfo.marketType,
        logpath: getQueryofKey('logpath') || '',
        tplPath: document.documentElement.getAttribute('page'),
        orifrom: getQueryofKey('orifrom') || '',
        ZYBUSS: getQueryofKey('token'),
        isAutoPoint: 1, // 是全埋点
        os: browser.os(),
        browser: browser.kernel(),
        actId: this.actInfo.actId,
        fcId: this.actInfo.actId,
        cuid: this.flowPond.cuid,
        pvid: this.flowPond.pvid,
        mofangActType: this.actInfo.source,
        pageType,
        // 定制内容素材id
        resultsContentId: answerResult && answerResult.analyMaterialId,
        // 课程介绍素材id
        courseIntroId: answerResult && answerResult.skuMaterialId,
      }
      if (
        +source === 1 &&
        +subSource === 102 &&
        terminalCheck.isInmimiProgram()
      ) {
        // 小程序内嵌H5的话，需要追加参数
        globalData = Object.assign(globalData, {
          unionID: getQueryofKey('unionID'),
          openID: getQueryofKey('openID'),
          wxuser: getQueryofKey('wxuser'),
          appID: getQueryofKey('appID'),
          mofangActSubType: 102,
        })
        args = args.concat([
          'unionID',
          'openID',
          'wxuser',
          'appID',
          'mofangActSubType',
        ])
      }
      // 全埋点
      var fn = zs
      // 如果未挂载
      if (!fn) {
        setTimeout(() => {
          this.initAllDotSdk()
        }, 200)
        return
      }
      const configObj: any = { platName: 'mofang', env: 'production' }
      fn.config(configObj)
      if (terminalType() === 'haokezaixian') {
        fn.setPlat('haokeAPP')
      } else if (terminalType() === 'homework_knowledge') {
        fn.setPlat('mjzybKnowledge')
      } else if (terminalType() === 'miaobao') {
        fn.setPlat('mbAPP')
      } else if (terminalType() === 'iot_app') {
        fn.setPlat('tyAPP')
      } else if (terminalType() === 'youketang') {
        fn.setPlat('yktAPP')
      }
      fn.setGlobalData(globalData)
      fn.setPageDots(mockPageDtos)
      fn.init()
      // 全埋点已准备完毕
      ;(window as any).__PAGE_DATA__.autoPointReady = true
    } catch (e) {
      console.log('e', e)
    }
  }
  /**
   * 页面展现和组件展现打点
   */
  handlePageDot() {
    this.componentDomArray = Array.from(
      document.querySelectorAll('.niffler-container')
    )
    this.fixedComponentDomArray = Array.from(
      document.querySelectorAll('.fixed-container')
    )
    // 组件PV
    this.$nextTick(() => {
      // 固定定位元素打点
      this.handleFixComponentsDot()
      // 非固定定位元素打点
      this.handleShowDot()
    })
    window.addEventListener('scroll', () => this.handleShowDot())
  }
  // 固定定位组件打点
  handleFixComponentsDot() {
    if (this.fixedComponentDomArray.length > 0) {
      let index = 0
      this.fixedComponentDomArray.forEach((item: any, num: any) => {
        let dotSelf =
          item.children &&
          item.children[0] &&
          item.children[0].getAttribute('dot-self')
        if (dotSelf) {
          return false
        }
        let niffleruid = item.getAttribute('niffleruid')
        let nifflerData = this.tempDomList[niffleruid]
        let { status, propsData } = nifflerData
        let impView
        if (
          propsData[status].actions.some((item: any) => {
            return (
              item.actionType === 'freeCourseWechat' ||
              item.actionType === 'freeCourseWechat2'
            )
          })
        ) {
          impView = 62
        }
        dotApi.componentShow({
          pageId: this.pageInfo.pageId,
          niffleruid: niffleruid,
          componentName: nifflerData.componentName,
          imp: impView || propsData[status].description['impView'],
          groupId: this.actInfo.groupId,
        })
        item.canDoted = false
        index = num + 1
        return true
      })
      this.fixedComponentDomArray.splice(0, index)
    }
  }
  /**
   * 组件展现点
   */
  handleShowDot() {
    if (this.componentDomArray.length > 0) {
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      let index = 0
      this.componentDomArray.forEach((item: any, num: any) => {
        let currentTop =
          item.offsetTop -
          (document.documentElement.scrollTop || document.body.scrollTop)
        let niffleruid = item.getAttribute('niffleruid')
        let nifflerType = item.getAttribute('data-type')
        let nifflerData = this.tempDomList[niffleruid]
        if (!nifflerData) return
        let { status, propsData } = nifflerData
        // 组件需要自己打点时dot-self为true
        let dotSelf =
          item.children[0] && item.children[0].getAttribute('dot-self')
        if (
          !dotSelf &&
          nifflerType &&
          !IgnoreDot.includes(Number(nifflerType)) &&
          currentTop <= clientHeight &&
          (item.canDoted || item.canDoted === undefined)
        ) {
          let impView
          if (
            propsData[status].actions.some((item: any) => {
              return (
                item.actionType === 'freeCourseWechat' ||
                item.actionType === 'freeCourseWechat2'
              )
            })
          ) {
            impView = 62
          }
          dotApi.componentShow({
            pageId: this.pageInfo.pageId,
            niffleruid: niffleruid,
            componentName: nifflerData.componentName,
            imp: impView || propsData[status].description['impView'],
            groupId: this.actInfo.groupId,
            customParams: {
              componentDisplayName:
                (item.children &&
                  item.children[0] &&
                  item.children[0].getAttribute('data-picname')) ||
                '',
            },
          })
          item.canDoted = false
          index = num + 1
        } else {
          return false
        }
        return true
      })
      try {
        // 出于性能考量，打点后仅留存还未打点的组件
        this.componentDomArray = this.componentDomArray.filter((item: any) => {
          return item.canDoted || item.canDoted === undefined
        })
      } catch (err) {}
    }
  }
  // 遍历组件，设置赠课跳转小程序事件的参数
  recursionComponentList(componentlist: any) {
    const componentList = componentlist || []
    componentList.forEach((item: any) => {
      if (
        item.propsData &&
        item.propsData['0'] &&
        item.propsData['0'].actions &&
        item.propsData['0'].actions[0]
      ) {
        if (item.propsData['0'].actions[0].actionType === 'freeCourseWechat2') {
          this.getWxInfo(item.propsData['0'].actions[0].params.appletTypeId)
        }
        // 获取specify、demo-specify小程序跳转详情
        if (
          item.propsData['0'].actions[0].actionType === 'openWxApplet' &&
          item.propsData['0'].actions[0].params
        ) {
          if (
            item.propsData['0'].actions[0].params.type === 'specify' ||
            item.propsData['0'].actions[0].params.type === 'demo-specify'
          ) {
            this.getOpenWxAppletInfo(
              item.propsData['0'].actions[0].params.appletTypeId
            )
          }
        }
      }
      // 公用这个递归，这里存储一下设置固定的组件的uid
      if (
        item.propsData &&
        item.propsData['0'] &&
        item.propsData['0'].style &&
        item.propsData['0'].style.position === 'fixed'
      ) {
        if ((window as any).__FixedComponentUid__) {
          ;(window as any).__FixedComponentUid__.push(item.uid)
        } else {
          ;(window as any).__FixedComponentUid__ = [item.uid]
        }
      }
      if (item.componentList && item.componentList.length > 0) {
        this.recursionComponentList(item.componentList)
      }
    })
  }
  // 获取小程序跳转详情
  getWxInfo(typeId: any) {
    request
      .get('/cube/api/applet/info', {
        type: 1,
        id: typeId,
        actionType: 3,
      })
      .then((res: any) => {
        let path = res.wxpath || ''
        let params = {
          userName: res.wxUserName,
          path,
          type: 0,
        }
        ;(window as any).__AppletTypeIdMap__[typeId] = params
      })
  }
  // 获取specify、demo-specify小程序跳转详情
  getOpenWxAppletInfo(typeId: any) {
    request
      .get('/cube/api/applet/info', {
        type: 1,
        id: typeId,
        actionType: 3,
      })
      .then((res: any) => {
        let wxpath = res.wxpath || ''
        let params = {
          wxUserName: res.wxUserName,
          wxpath,
          type: 0,
        }
        ;(window as any).__OpentWxAppletTypeIdMap__[typeId] = params
      })
  }
}
